module.exports = __webpack_public_path__ + "img/clientesActualizadosResponsive1.f22d3d5f.png";